export default [
  {
    id: 'checkout',
    importFunction: () => import(/* webpackChunkName: "checkout" */ '@/apps/checkout'),
    activeUnder: [
      'checkout/'
    ],
    isActive: () => true
  },
  {
    id: 'assessment-legacy',
    importFunction: () => import(/* webpackChunkName: "assessment-legacy" */ '@/entry-points/assessment-legacy'),
    activeUnder: [],
    isActive: () => true
  }
]
